import {
  AuthOutcome,
  displayError,
  processDialogEventForTenant,
  queryParams,
  tenantConfOrDisplayError,
} from "./DialogCommons";
import { store } from "../../redux/store/store";
import { updateAuthDataForTenantConf } from "../../redux/feature/settings/configurations-slice";

const dialogLoginUrl = () => window.location.origin + "/login/login.html";

export const login = (tenantId: string): Promise<AuthOutcome> => {
  let loginDialog: Office.Dialog;

  return new Promise<AuthOutcome>((resolve, reject) => {
    if (tenantConfOrDisplayError(tenantId)) {
      const dialogLoginUrlWithParams = `${dialogLoginUrl()}?${queryParams(tenantId)}`;
      Office.context.ui.displayDialogAsync(
        dialogLoginUrlWithParams,
        { height: 65, width: 30, promptBeforeOpen: false }, //don't factorize me there's a bug preventing dialog to reopen
        (result) => {
          if (result.status === Office.AsyncResultStatus.Failed) {
            displayError("Login Error", `${result.error.code} ${result.error.message}`);
            reject(new Error("Login Error"));
          } else {
            loginDialog = result.value;
            loginDialog.addEventHandler(Office.EventType.DialogMessageReceived, processLoginMessage);
            loginDialog.addEventHandler(Office.EventType.DialogEventReceived, processLoginDialogEvent);
          }
        }
      );
    } else {
      reject(new Error("TenantConfOrDisplayError"));
    }

    function processLoginMessage(arg) {
      let messageFromDialog = JSON.parse(arg.message);
      loginDialog.close();
      if (messageFromDialog.status === "success") {
        // We now have a valid access token.
        const authData = messageFromDialog.result;

        console.log("authData received");
        store.dispatch(updateAuthDataForTenantConf({ authData: authData, tenantId: tenantId }));
        resolve({ authData: authData });
      } else {
        // Something went wrong with authentication or the authorization of the web application.
        displayError("Login Error", messageFromDialog.result);
        reject(new Error("Login Error"));
      }
    }

    function processLoginDialogEvent(arg) {
      processDialogEventForTenant(arg, tenantId);
      reject(new Error("processDialogEventForTenant didn't resolve"));
    }
  });
};
